module.exports = __webpack_public_path__ + "static/media/john_player_ignite_col_logo.baba44ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/john_player_ignite_col_logo.png
// module id = 1661
// module chunks = 0